<template>
  <div>
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <div style="margin-top: 12px">
      <el-table
        :data="list"
        v-loading="listLoading"
        style="width: 100%"
        ref="table"
        class="custom-tbl"
      >
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column
          prop="Type"
          label="类型"
          :formatter="formatType"
        ></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="scope.row.Adress"
              fit="cover"
              :preview-src-list="[scope.row.Adress]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="OrderSort"></el-table-column>
        <el-table-column label="页面路径" prop="Path"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="plain" size="mini" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="mini" @click="handleDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="page.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="page.intPageSize"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-form-item label="类型" prop="Type">
            <el-select v-model="addForm.Type">
              <el-option label="推荐" value="1"></el-option>
              <el-option label="轮播" value="2"></el-option>
              <el-option label="优选" value="3"></el-option>
              <el-option label="场馆" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片" prop="Adress">
            <Upload
              @upload="handleUpload"
              @delete="handleRemove"
              :fileUrl="addForm.Adress"
              :type="uploadType"
            ></Upload>
          </el-form-item>
          <el-form-item label="排序" prop="OrderSort">
            <el-input-number
              :min="0"
              :step="1"
              v-model="addForm.OrderSort"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="页面路径" prop="Path">
            <el-input v-model="addForm.Path"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-form-item label="类型" prop="Type">
            <el-select v-model="editForm.Type">
              <el-option label="推荐" value="1"></el-option>
              <el-option label="轮播" value="2"></el-option>
              <el-option label="优选" value="3"></el-option>
              <el-option label="场馆" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片" prop="Adress">
            <Upload
              @upload="handleEditUpload"
              @delete="handleEditRemove"
              :fileUrl="editForm.Adress"
              :type="uploadType"
            ></Upload>
          </el-form-item>
          <el-form-item label="排序" prop="OrderSort">
            <el-input-number
              :min="0"
              :step="1"
              v-model="editForm.OrderSort"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="页面路径" prop="Path">
            <el-input v-model="editForm.Path"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  carouseList,
  addCarouse,
  deleteCarouse,
  updateCarouse,
} from "@/api/carouse/carouse";
import Upload from "../../components/Upload";
import util from "../../../util/date";
export default {
  components: { Toolbar, Upload },
  data() {
    return {
      page: {
        page: 1,
        intPageSize: 10,
      },
      listLoading: false,
      total: 0,
      list: [],
      buttonList: [],
      addFormVisible: false,
      addFormRules: {},
      addForm: {},
      addLoading: false,
      editFormVisible: false,
      editFormRules: {},
      editForm: {},
      editLoading: false,
      filters: {},
      filterParams: {
        key: "",
      },
    };
  },
  created() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
  },
  computed: {
    uploadType() {
      return this.addForm.Type == 4
        ? "venue"
        : this.addForm.Type == 2
        ? "match"
        : this.addForm.Type == 1
        ? "tuijian"
        : "preferred";
    },
  },
  methods: {
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let para = Object.assign({}, this.editForm);
          updateCarouse(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.editLoading = false;
              return;
            }
            if (res.data.success) {
              this.editLoading = false;

              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.initPage();
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    handleEdit(row) {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    handleDel(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteCarouse({
          Id: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          addCarouse(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.addLoading = false;
              return;
            }
            if (res.data.success) {
              this.addLoading = false;

              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$refs["addForm"].resetFields();

              this.addFormVisible = false;
              this.initPage();
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    handleUpload(e) {
      this.addForm.Adress = e;
    },
    handleRemove() {
      this.addForm.Adress = "";
    },
    handleEditUpload(e){
      this.editForm.Adress = e
    },
    handleEditRemove(){
      this.editForm.Adress = ''
    },
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {};
    },
    formatType(row, column, cellValue, index) {
      return cellValue == 1 ? "推荐" : cellValue == 2 ? "赛事" : "优选";
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.intPageSize = val;
      this.getList();
    },
    initPage() {
      this.page.page = 1;
      this.page.intPageSize = 10;
      this.filters = {
        key: "",
      };
    },

    getList() {
      let params = { ...this.filterParams, ...this.page };
      this.listLoading = true;
      carouseList(params)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>